import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Ai\ChatController::__invoke
* @see app/Http/Controllers/Ai/ChatController.php
* @route '/api/ai/chat'
*/
const ChatController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: ChatController.url(options),
    method: 'post',
})

ChatController.definition = {
    methods: ["post"],
    url: '/api/ai/chat',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Ai\ChatController::__invoke
* @see app/Http/Controllers/Ai/ChatController.php
* @route '/api/ai/chat'
*/
ChatController.url = (options?: RouteQueryOptions) => {
    return ChatController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Ai\ChatController::__invoke
* @see app/Http/Controllers/Ai/ChatController.php
* @route '/api/ai/chat'
*/
ChatController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: ChatController.url(options),
    method: 'post',
})

export default ChatController